import React from 'react';
import i18next from 'i18next';
import EventTopInfo from './EventTopInfo/EventTopInfo';
import EventBlock from './EventBlock/EventBlock';
import { connect } from 'react-redux';
import { setEvent } from '../../../actions/eventsActions';
import { setChannel } from '../../../actions/playerActions';
import { setSearchFilter } from '../../../actions/eventsActions';
import TwitchPlayer from '../../TwitchPlayer/TwitchPlayer';
import Market from '../Market/Market';
import MarketTable from '../MarketTable/MarketTable';
import Masonry from 'react-masonry-component';
import MarketsFilter from '../MarketsFilter/MarketsFilter';
import classNames from 'classnames';
import ButtonBorder from '../../Button/ButtonBorder';
import Icon from '../../Icon/Icon';
import lockCloseIcon from 'icons/lock-close.svg';
import makeCancelable from '../../../api/cancelable';
import EApi from '../../../api/esports';
import { gameLogo } from '../../../utils';

class EventPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      marketsFilter: null,
      notFound: false,
    };

    this.timer = null;
    this.requests = [];
  }

  componentDidMount() {
    this.props.setSearchFilter('');

    if (!this.props.event) {
      this.loadEndedEvent();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.requests.forEach((cancel) => cancel());
    this.props.setEvent(null);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.event && !this.props.event) {
      console.log('event ended');
      this.loadEndedEvent();
    }
  }

  loadEndedEvent = () => {
    const { promise, cancel } = makeCancelable(
      EApi.loadEvent(this.props.eventId)
    );
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.props.setEvent(response.events);
      } else {
        this.setState({ notFound: true });
      }
    });
  };

  changeFilter = (filter) => {
    let activeFilter = this.state.marketsFilter;

    if (filter === activeFilter) {
      this.setState({ marketsFilter: null });
    } else {
      this.setState({ marketsFilter: filter });
    }
  };

  getFilters() {
    const { markets } = this.props.event;

    return Object.keys(
      Object.keys(markets).reduce((acc, m) => {
        const fs = markets[m]['filter'];
        fs.forEach((f) => {
          acc[f] = true;
        });
        return acc;
      }, {})
    );
  }

  render() {
    const { event } = this.props;
    const { notFound } = this.state;

    if (notFound)
      return (
        <div className="event-page">
          <div className="event-page__not-found">
            {i18next.t('errors.event_not_found_or_ender')}
          </div>
        </div>
      );

    if (!event) return null;

    const {
      date_start,
      name_at,
      name_ht,
      logo_at,
      logo_ht,
      ch_name,
      game,
      comment,
      score,
      score_dop,
      status,
      broadcast_channel,
    } = event;

    const mainMarket = event.main_bet;

    return (
      <div className="event-page">
        <EventTopInfo
          date={date_start}
          map={comment}
          open={+status === 0}
          league={ch_name}
          game={game}
          gameLogo={gameLogo(game)}
        />
        {broadcast_channel && <TwitchPlayer channel={broadcast_channel} />}
        <Market marketId={mainMarket} renderAnyway={true}>
          {({ outcomes, market }) => {
            const withDraw = market && +market.column === 3;
            const homeBet = outcomes[0];
            const drawBet =
              withDraw && outcomes.length === 3 ? outcomes[1] : null;
            const awayBet = outcomes[withDraw ? 2 : 1];

            return (
              <div className="event-page__events">
                <EventBlock
                  team={name_ht}
                  logo={`/img/logo/${logo_ht}`}
                  bet={homeBet}
                />
                <div className="event-page__middle">
                  <div className="event-page__vs">VS</div>
                  <div className="event-page__score">
                    <span> {score} </span> {score_dop ? `(${score_dop})` : ''}
                  </div>

                  {withDraw && (
                    <React.Fragment>
                      <div className="event-page__draw-title">
                        {i18next.t('draw')}
                      </div>
                      {drawBet && drawBet.status && drawBet.cf ? (
                        <ButtonBorder
                          onClick={drawBet.toggleBet}
                          className={classNames('event-page__draw', {
                            active: drawBet.selected,
                          })}
                        >
                          {drawBet.cf.toFixed(2)}
                        </ButtonBorder>
                      ) : (
                        <ButtonBorder
                          className={classNames('event-page__draw', {
                            disabled: true,
                          })}
                        >
                          <Icon glyph={lockCloseIcon} />
                        </ButtonBorder>
                      )}
                    </React.Fragment>
                  )}
                </div>
                <EventBlock
                  team={name_at}
                  logo={`/img/logo/${logo_at}`}
                  bet={awayBet}
                  right={true}
                />
              </div>
            );
          }}
        </Market>

        <MarketsFilter
          filters={this.getFilters()}
          activeFilter={this.state.marketsFilter}
          onChange={this.changeFilter}
        />

        <Masonry
          className={'event-page__markets'}
          options={{
            gutter: 10,
          }}
        >
          {Object.keys(event.markets).map((marketTitle) => {
            const filters = event.markets[marketTitle]['filter'];
            const activeFilter = this.state.marketsFilter;
            const render =
              !activeFilter ||
              filters.filter((f) => f === activeFilter).length > 0;

            return (
              render && (
                <MarketTable
                  data={event.markets[marketTitle]}
                  event={event}
                  title={marketTitle}
                  key={marketTitle}
                />
              )
            );
          })}
        </Masonry>
      </div>
    );
  }
}

export default connect(
  (state, props) => {
    const { eventId } = props.match.params;
    const getEvent = (eventId) =>
      state.events['prematch'][eventId] || state.events['live'][eventId];
    const event = getEvent(eventId) || state.events.event;

    return {
      eventId,
      event,
    };
  },
  {
    setEvent,
    setChannel,
    setSearchFilter,
  }
)(EventPage);



// WEBPACK FOOTER //
// ./app/components/EsportsGame/EventPage/EventPage.jsx